import type { PageAdSize } from './types'

export type PageAdSlotRect = {
    height: number
    width: number
}

type GetPageAdSizesForSlotOptions = {
    respectHeight?: boolean
    sizes: PageAdSize[]
}

export function getPageAdSizesForSlot(
    rect: PageAdSlotRect,
    { respectHeight = false, sizes }: GetPageAdSizesForSlotOptions,
): PageAdSize[] {
    return sizes
        .slice()
        .sort((a, b) => {
            if (a === 'fluid') {
                return 1
            }
            if (b === 'fluid') {
                return -1
            }
            return b[0] - a[0]
        })
        .filter((size) => {
            if (size === 'fluid') {
                return rect.width > 0
            }

            const heightFits = !respectHeight || rect.height >= size[1]
            return rect.width >= size[0] && heightFits
        })
}
